import moment from 'moment';
import { createReducer } from 'typesafe-actions';
import withJobs from '../../_core/job/reducers';
import {
    IBFL2Store,
    TBFL2Record,
} from './@types';
import bfl2Actions, { EBFL2Constants, TBFL2Actions } from './actions';

const defaultState: IBFL2Store = {
    _jobs: {},
    currentOperation: undefined,
    records: {
        byIds: {},
        ids: [],
    },
    filter: {
        startDate: moment().subtract(7, 'days').toDate(),
        endDate: moment().add(1, 'day').toDate(),
        shownRecords: 'ALL',
    },
};
const bfl2Reducers = createReducer<IBFL2Store, TBFL2Actions>(defaultState)
    .handleAction(
        bfl2Actions.document.historySet,
        function historySet(state, action) {
            return {
                ...state,
                records: action.payload.history,
            };
        }
    )
    .handleAction(
        bfl2Actions.document.setFilter,
        function setFilter(state, action) {
            return {
                ...state,
                filter: action.payload.filter,
            };
        }
    );

export default withJobs<IBFL2Store>(
    EBFL2Constants.FEATURE,
    defaultState,
    bfl2Reducers
);
